import React from 'react';
import QRCodeComponent from 'react-qr-code';
import qrCodeStyles from 'sulu-admin-bundle/components/QRCode/qrcode.scss';
import {Button, ButtonGroup, Icon} from 'sulu-admin-bundle/components';

const getQrSvgNode = () => document.querySelector('svg[class^="qrcode-"]');

const ensureSvgNamespaces = (source) => {
    let result = source;

    if (!result.match(/<svg[^>]*xmlns=\"http:\/\/www.w3.org\/2000\/svg\"/)) {
        result = result.replace(/<svg(\s|>)/, '<svg xmlns="http://www.w3.org/2000/svg"$1');
    }
    if (!result.match(/<svg[^>]*xmlns:xlink=\"http:\/\/www.w3.org\/1999\/xlink\"/)) {
        result = result.replace(/<svg([^>]*)>/, '<svg$1 xmlns:xlink="http://www.w3.org/1999/xlink">');
    }

    return result;
};

const downloadBlob = (blob, filename) => {
    const a = document.createElement('a');
    const url = URL.createObjectURL(blob);

    a.href = url;
    a.download = filename;

    a.click();
    setTimeout(() => URL.revokeObjectURL(url), 0);
};

const downloadDataUrl = (dataUrl, filename) => {
    const a = document.createElement('a');

    a.href = dataUrl;
    a.download = filename;

    a.click();
};

const svgToImageDataUrl = async ({
    svg,
    mimetype = 'image/png',
    quality = 0.92,
    width = 1024,
    height = 1024,
}) => new Promise((resolve, reject) => {
    const svgNode = typeof svg === 'string' ? (() => {
        const container = document.createElement('div');
        container.style.display = 'none';
        container.innerHTML = svg;

        return container.firstElementChild;
    })() : svg;

    const canvas = document.createElement('canvas');
    const context = canvas.getContext('2d');

    const svgXml = new XMLSerializer().serializeToString(svgNode);
    const svgBase64 = 'data:image/svg+xml;base64,' + btoa(svgXml);

    const image = new Image();
    image.onload = function onload() {
        let finalWidth;
        let finalHeight;

        if (width === 'auto' && height !== 'auto') {
            finalWidth = (this.width / this.height) * height;
        } else if (width === 'auto') {
            finalWidth = this.naturalWidth;
        } else {
            finalWidth = width;
        }

        if (height === 'auto' && width !== 'auto') {
            finalHeight = (this.height / this.width) * width;
        } else if (height === 'auto') {
            finalHeight = this.naturalHeight;
        } else {
            finalHeight = height;
        }

        canvas.width = finalWidth;
        canvas.height = finalHeight;
        context.drawImage(this, 0, 0, finalWidth, finalHeight);
        resolve(canvas.toDataURL(mimetype, quality));
    };
    image.onerror = reject;
    image.src = svgBase64;
});

const ProductQRCode = ({data}) => {
    const handleDownloadPng = async () => {
        try {
            const svgNode = getQrSvgNode();
            if (!svgNode) return;
            const dataUrl = await svgToImageDataUrl({ svg: svgNode, quality: 1 });

            downloadDataUrl(dataUrl, 'qrcode.png');
        } catch (err) {
            // keep quiet as before
            // eslint-disable-next-line no-console
            console.log(err);
        }
    };

    const handleDownloadSvg = () => {
        try {
            const svgNode = getQrSvgNode();
            if (!svgNode) return;

            const serializer = new XMLSerializer();
            const raw = serializer.serializeToString(svgNode);
            const source = ensureSvgNamespaces(raw);
            const blob = new Blob([source], { type: 'image/svg+xml;charset=utf-8' });
            downloadBlob(blob, 'qrcode.svg');
        } catch (e) {
            // eslint-disable-next-line no-console
            console.log(e);
        }
    };

    return (
        <>
            <ButtonGroup>
                <Button skin="primary" onClick={handleDownloadPng}>
                    <span>PNG <Icon name="su-download" /></span>
                </Button>
                <Button skin="secondary" onClick={handleDownloadSvg}>
                    <span>SVG <Icon name="su-download" /></span>
                </Button>
            </ButtonGroup>
            <QRCodeComponent
                className={qrCodeStyles.qrcode}
                value={(data && data.product_url) || ''}
                viewBox="0 0 256 256"
                size="80"
            />
        </>
    );
};

export default ProductQRCode;